import { render, staticRenderFns } from "./UserFormNew.vue?vue&type=template&id=ed362406&"
import script from "./UserFormNew.vue?vue&type=script&lang=js&"
export * from "./UserFormNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports